export const introText = {
  en: {
    title: "About Me",
    description: `I am a person who has taken wrong turns, made career shifts,
and experienced breaks — yet ultimately discovered the path
that suited me best.

Now, I’m here to help you do the same, with greater ease
and confidence.`,
  },

  vi: {
    title: "Về Tôi",
    description: `Tôi từng rẽ sai hướng, thay đổi nghề nghiệp,
và có những quãng dừng trong hành trình sự nghiệp —
nhưng cuối cùng đã tìm ra con đường phù hợp nhất với mình.

Giờ đây, tôi ở đây để đồng hành cùng bạn,
giúp bạn tìm ra con đường đúng đắn
một cách nhẹ nhàng và vững vàng hơn.`,
  },
};
